import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { ReferenceService } from '../../generated/auth/services/reference.service';
import {
  loadIndustriesOrSectors,
  loadIndustriesOrSectorsFailure,
  loadIndustriesOrSectorsSuccess,
  toggleIndustriesOrSectorsLoading,
} from './industries-or-sectors.actions';
import { selectIndustriesOrSectorsList, selectIndustriesOrSectorsLoading } from './industries-or-sectors.selectors';

@Injectable()
export class IndustriesOrSectorsEffects {
  private actions$ = inject(Actions);
  private referenceService = inject(ReferenceService);
  private store = inject(Store);

  constructor() {}

  loadIndustriesOrSectors$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadIndustriesOrSectors),
      withLatestFrom(
        this.store.select(selectIndustriesOrSectorsLoading),
        this.store.select(selectIndustriesOrSectorsList),
      ),
      filter(([action, isLoading, list]) => !isLoading && (!list || list.length === 0)),
      tap(() => this.store.dispatch(toggleIndustriesOrSectorsLoading({ isLoading: true }))),
      switchMap(() =>
        this.referenceService.referenceLookupGetIndustriesOrSectorsGet().pipe(
          map((response) => loadIndustriesOrSectorsSuccess({ industriesOrSectors: response.result || [] })),
          catchError((error) => of(loadIndustriesOrSectorsFailure({ error }))),
        ),
      ),
    ),
  );
}
